import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { debounce } from 'lodash';
import domReady from '../helpers/dom-ready';

class Menu {
  static init() {
    return new Menu();
  }

  constructor() {
    this.menu = document.querySelector('.brix-menu');
    this.logo = document.querySelector('.logo');
    this.fullMenu = this.menu.querySelector('.full-menu');
    this.toggleMenuButton = this.menu.querySelector('.menu-button');
    this.menuWrapper = this.menu.querySelector('.menu-wrapper');
    this.menuList = this.menu.querySelector('.menu');
    // Search
    this.searchForm = this.menu.querySelector('.search-form');

    if (this.searchForm) {
      this.toggleSearchButton = this.menu.querySelector('.toggle-search-button');
      this.searchTextInput = this.searchForm.querySelector('.search-input');
      this.searchButton = this.searchForm.querySelector('.search-button');
    }

    // Language switchers
    this.languageSwitchers = this.menu.querySelectorAll('.language-switcher > select');

    this.isMenuOpen = false;
    this.overflowBreakpoint = null;

    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener('scroll', debounce(() => {
      this.toggleMenuButtonBackground();
    }), 300);

    this.toggleMenuButton.addEventListener('click', () => {
      this.toggleIsMenuOpen();
    });

    this.menu.addEventListener('transitionend', (e) => {
      if (e.target !== this.menu) { return; }

      if (e.propertyName === 'height') {
        this.menu.classList.remove('-closing');
      }
    });

    if (this.searchForm) {
      this.toggleSearchButton.addEventListener('click', () => {
        this.toggleIsMenuOpen();
        this.searchTextInput.focus();
      });

      this.searchButton.addEventListener('click', (e) => {
        this.search(e);
      });
    }

    if (this.languageSwitchers.length > 0) {
      [...this.languageSwitchers].forEach((el) => {
        el.addEventListener('change', () => {
          this.changeLanguage(el);
        });
      });
    }
  }

  checkOverflow() {
    const isOverflowing = this.menuWrapper.clientWidth < this.menuWrapper.scrollWidth;

    if (!this.overflowBreakpoint && isOverflowing) {
      this.overflowBreakpoint = window.innerWidth;
      this.menu.classList.add('-overflow');
    }

    if (this.overflowBreakpoint && window.innerWidth > this.overflowBreakpoint) {
      this.overflowBreakpoint = null;
      this.menu.classList.remove('-overflow');
    }
  }

  checkOpenMenu() {
    const breakpoint = this.overflowBreakpoint ? this.overflowBreakpoint : 576;

    if (window.innerWidth > breakpoint && this.isMenuOpen) {
      this.toggleIsMenuOpen();
    }
  }

  toggleMenuButtonBackground() {
    if (window.scrollY > 50) {
      this.toggleMenuButton.classList.add('-background');
    } else {
      this.toggleMenuButton.classList.remove('-background');
    }
  }

  toggleIsMenuOpen() {
    this.menu.classList.toggle('-open-menu');
    this.isMenuOpen = !this.isMenuOpen;

    if (this.isMenuOpen) {
      disableBodyScroll(this.fullMenu);
    } else {
      enableBodyScroll(this.fullMenu);
      this.menu.classList.add('-closing');
    }
  }

  search(e) {
    e.preventDefault();

    if (this.searchTextInput.value === '') {
      this.searchTextInput.focus();
    } else {
      const { searchUrl } = this.searchForm.dataset;
      const searchQuery = encodeURIComponent(this.searchTextInput.value).replace(/%20/g, '+');

      window.location.href = `${searchUrl}?search=${searchQuery}`;
    }
  }

  changeLanguage(el) {
    const option = el.options[el.selectedIndex];

    if (option && option.value) {
      if (option.dataset.slug && window.pll_set_current_language) {
        window.pll_set_current_language(option.dataset.slug);
      }

      window.location.href = option.value;
    }
  }
}

domReady(() => {
  Menu.init();
});
